/* LumosClock Homepage v2 — Boutique edition interactions
   (Claude Design export, 2026-07-14)
   Scope: scroll-reveal, FAQ accordion, sticky mobile buy-bar, language dropdown,
   live word clock (SVG-versie uit de Claude Design export — exact dezelfde
   opbouw/uitlijning als het ontwerp, i.p.v. het oudere foto-based component). */
(function () {
  'use strict';

  /* Live word clock — Hero (dynamic, volgt de echte tijd; EN + IT) */
  (function () {
    var root = document.querySelector('[data-live-word-clock-hero]');
    if (!root) return;
    var grid = root.querySelector('[data-clock-grid]');
    if (!grid) return;
    var locale = (root.getAttribute('data-locale') || 'en').slice(0, 2);

    var EN_HOURS = ['TWELVE', 'ONE', 'TWO', 'THREE', 'FOUR', 'FIVE_H', 'SIX', 'SEVEN', 'EIGHT', 'NINE', 'TEN_H', 'ELEVEN'];
    var IT_HOURS = ['DODICI', 'UNA', 'DUE', 'TRE', 'QUATTRO', 'CINQUE_H', 'SEI', 'SETTE', 'OTTO', 'NOVE', 'DIECI_H', 'UNDICI'];

    function setWord(word, on) {
      var nodes;
      if (locale === 'it' && word === 'VENTI') {
        nodes = grid.querySelectorAll('.it-venti');
      } else if (locale === 'it' && word === 'E_CON') {
        nodes = grid.querySelectorAll('.it-econ');
      } else if (locale === 'it' && word === 'CINQUE_M_20') {
        nodes = grid.querySelectorAll('.it-cinque_m');
      } else {
        nodes = grid.querySelectorAll('[data-w="' + word + '"]');
      }
      for (var j = 0; j < nodes.length; j++) nodes[j].classList.toggle('on', on);
    }
    function clearAll() {
      var lit = grid.querySelectorAll('[data-w].on, .it-venti.on, .it-econ.on, .it-cinque_m.on');
      for (var j = 0; j < lit.length; j++) lit[j].classList.remove('on');
    }

    function renderEN() {
      var now = new Date();
      var h = now.getHours(), m = now.getMinutes();
      var block = Math.floor(m / 5), dots = m % 5;
      var cur = h % 12, disp = block >= 7 ? (cur + 1) % 12 : cur;
      clearAll();
      var words = ['ITS'];
      switch (block) {
        case 0: words.push(EN_HOURS[disp], 'OCLOCK'); break;
        case 1: words.push('FIVE_M', 'MINUTES', 'PAST', EN_HOURS[disp]); break;
        case 2: words.push('TEN_M', 'MINUTES', 'PAST', EN_HOURS[disp]); break;
        case 3: words.push('A', 'QUARTER', 'PAST', EN_HOURS[disp]); break;
        case 4: words.push('TWENTY', 'MINUTES', 'PAST', EN_HOURS[disp]); break;
        case 5: words.push('TWENTY', 'FIVE_M', 'MINUTES', 'PAST', EN_HOURS[disp]); break;
        case 6: words.push('HALF', 'PAST', EN_HOURS[disp]); break;
        case 7: words.push('TWENTY', 'FIVE_M', 'MINUTES', 'TO', EN_HOURS[disp]); break;
        case 8: words.push('TWENTY', 'MINUTES', 'TO', EN_HOURS[disp]); break;
        case 9: words.push('A', 'QUARTER', 'TO', EN_HOURS[disp]); break;
        case 10: words.push('TEN_M', 'MINUTES', 'TO', EN_HOURS[disp]); break;
        case 11: words.push('FIVE_M', 'MINUTES', 'TO', EN_HOURS[disp]); break;
      }
      for (var k = 0; k < words.length; k++) setWord(words[k], true);
      var dotSpans = root.querySelectorAll('[data-dot]');
      for (var d = 0; d < dotSpans.length; d++) dotSpans[d].classList.toggle('on', d < dots);
    }

    function renderIT() {
      var now = new Date();
      var h = now.getHours(), m = now.getMinutes();
      var block = Math.floor(m / 5), dots = m % 5;
      var cur = h % 12;
      var disp = block >= 7 ? (cur + 1) % 12 : cur;
      clearAll();
      var words = [];
      if (disp === 1) {
        words.push('E_ACC', 'L_UNA', 'UNA');
      } else {
        words.push('SONO', 'LE', IT_HOURS[disp]);
      }
      switch (block) {
        case 0: break;
        case 1: words.push('E_CON', 'CINQUE_M_20'); break;
        case 2: words.push('E_CON', 'DIECI_M'); break;
        case 3: words.push('E_CON', 'UN', 'QUARTO'); break;
        case 4: words.push('E_CON', 'VENTI'); break;
        case 5: words.push('E_CON', 'VENTICINQUE'); break;
        case 6: words.push('E_CON', 'MEZZA'); break;
        case 7: words.push('MENO', 'VENTICINQUE'); break;
        case 8: words.push('MENO', 'VENTI'); break;
        case 9: words.push('MENO', 'UN', 'QUARTO'); break;
        case 10: words.push('MENO', 'DIECI_M'); break;
        case 11: words.push('MENO', 'CINQUE_M_20'); break;
      }
      for (var k = 0; k < words.length; k++) setWord(words[k], true);
      var dotSpans = root.querySelectorAll('[data-dot]');
      for (var d = 0; d < dotSpans.length; d++) dotSpans[d].classList.toggle('on', d < dots);
    }

    var render = locale === 'it' ? renderIT : renderEN;
    render();
    setInterval(render, 1000);
  })();

  /* Scroll reveal */
  (function () {
    var els = document.querySelectorAll('.rv');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  })();

  /* Smooth "floating" in-page scroll for anchor links (hero CTAs, footer,
     FAQ/personalise/story links, etc.) — replaces the native anchor jump
     with an eased, slower scroll for a more weightless feel. */
  (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Bij "reduce motion" niet volledig uitschakelen (dat gaf een harde sprong,
    // omdat de browser ook CSS scroll-behavior:smooth negeert) — maar een korte,
    // rustige scroll gebruiken i.p.v. de volle glide.
    var DURATION = reduceMotion ? 450 : 1100;

    function easeOutQuint(t) { return 1 - Math.pow(1 - t, 5); }

    function smoothScrollTo(target, duration) {
      var startY = window.scrollY;
      var targetY = target.getBoundingClientRect().top + startY;
      var diff = targetY - startY;
      var start;
      function step(ts) {
        if (start === undefined) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        window.scrollTo(0, startY + diff * easeOutQuint(progress));
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;
      var hash = link.getAttribute('href');
      if (!hash || hash === '#') return;
      var target = document.getElementById(hash.slice(1));
      if (!target) return;
      e.preventDefault();
      smoothScrollTo(target, DURATION);
      if (history.pushState) history.pushState(null, '', hash);
    });
  })();

  /* FAQ — smooth accordion, one open at a time */
  (function () {
    var faqItems = document.querySelectorAll('.faq-list .faq-item');
    var DURATION = 320;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function closeItem(item) {
      var answer = item.querySelector('.answer');
      if (!answer) return;
      answer.style.height = '';
      answer.style.opacity = '';
      answer.style.transition = '';
      item.removeAttribute('open');
    }

    function openItem(item) {
      var answer = item.querySelector('.answer');
      if (!answer || item._animating) return;
      item.setAttribute('open', '');
      if (reduceMotion) return;
      item._animating = true;
      answer.style.height = '0px';
      answer.style.opacity = '0';
      answer.style.transition = 'none';
      var endH = answer.scrollHeight;
      requestAnimationFrame(function () {
        answer.style.transition = 'height ' + DURATION + 'ms ease, opacity ' + DURATION + 'ms ease';
        answer.style.height = endH + 'px';
        answer.style.opacity = '1';
        var onEnd = function (e) {
          if (e.propertyName !== 'height') return;
          answer.removeEventListener('transitionend', onEnd);
          answer.style.height = '';
          answer.style.transition = '';
          item._animating = false;
        };
        answer.addEventListener('transitionend', onEnd);
      });
    }

    faqItems.forEach(function (item) {
      var summary = item.querySelector('summary');
      if (!summary) return;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (item._animating) return;
        if (item.open) {
          closeItem(item);
        } else {
          faqItems.forEach(function (other) {
            if (other !== item && other.open) closeItem(other);
          });
          openItem(item);
        }
      });
    });
  })();

  /* Sticky-buy show on scroll past hero */
  (function () {
    var sticky = document.getElementById('sticky-buy');
    var hero = document.getElementById('top');
    if (!sticky || !hero) return;
    window.addEventListener('scroll', function () {
      var below = (window.scrollY > (hero.offsetTop + hero.offsetHeight - 200));
      sticky.classList.toggle('visible', below);
    });
  })();

  /* Language dropdown */
  (function () {
    var wrap = document.querySelector('.lang-switch');
    if (!wrap) return;
    var trigger = wrap.querySelector('.lang-trigger');
    if (!trigger) return;
    function close() { wrap.classList.remove('open'); trigger.setAttribute('aria-expanded', 'false'); }
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = wrap.classList.toggle('open');
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  })();

})();
